// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.escher-container .scaleEditor * {
  font-size: 12px;
  color: #777;
  box-sizing: border-box;
}

.escher-container .scaleEditor {
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.escher-container .scaleTrack {
  position: relative;
  display: flex;
  height: 30px;
  margin-bottom: 9px;
  margin-top: 30px;
  margin-left: 55px;
  font-size: 15px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.escher-container .scaleTrack.disabled {
  background: #f1ecfa;
  color: #b19ec0;
  padding: 4px 0;
  justify-content: center;
}

.escher-container .gradient {
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.escher-container .scaleLabels {
  display: inline-flex;
  flex-direction: column;
  font-size: 12px;
}

.escher-container .scaleLabels label {
  padding: 4px 0;
}

.escher-container .noDataStyle {
  position: relative;
  margin-top: 20px;
}

.escher-container .noDataStyle .styleHeader {
  font-size: 12px;
  font-weight: bold;
}

.escher-container .noDataStyle label {
  margin-right: 5px;
}

.escher-container .noDataStyle input[type=text] {
  margin-right: 10px;
  padding: 3px 0px;
  width: 86px;
}

.escher-container .noDataStyle input[type=color] {
  position: absolute;
  padding: 0px;
  border: 1px solid black;
  left: 103px;
  height: 24px;
  width: 21px;
}

.escher-container .scaleEditor .icon-plus {
  cursor: pointer;
  position: absolute;
  font-size: 14px;
  right: 19px;
}
`, "",{"version":3,"sources":["webpack://./src/ScaleSlider.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb","sourcesContent":[".escher-container .scaleEditor * {\n  font-size: 12px;\n  color: #777;\n  box-sizing: border-box;\n}\n\n.escher-container .scaleEditor {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.escher-container .scaleTrack {\n  position: relative;\n  display: flex;\n  height: 30px;\n  margin-bottom: 9px;\n  margin-top: 30px;\n  margin-left: 55px;\n  font-size: 15px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.escher-container .scaleTrack.disabled {\n  background: #f1ecfa;\n  color: #b19ec0;\n  padding: 4px 0;\n  justify-content: center;\n}\n\n.escher-container .gradient {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n}\n\n.escher-container .scaleLabels {\n  display: inline-flex;\n  flex-direction: column;\n  font-size: 12px;\n}\n\n.escher-container .scaleLabels label {\n  padding: 4px 0;\n}\n\n.escher-container .noDataStyle {\n  position: relative;\n  margin-top: 20px;\n}\n\n.escher-container .noDataStyle .styleHeader {\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.escher-container .noDataStyle label {\n  margin-right: 5px;\n}\n\n.escher-container .noDataStyle input[type=text] {\n  margin-right: 10px;\n  padding: 3px 0px;\n  width: 86px;\n}\n\n.escher-container .noDataStyle input[type=color] {\n  position: absolute;\n  padding: 0px;\n  border: 1px solid black;\n  left: 103px;\n  height: 24px;\n  width: 21px;\n}\n\n.escher-container .scaleEditor .icon-plus {\n  cursor: pointer;\n  position: absolute;\n  font-size: 14px;\n  right: 19px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
